import GroupIcon from '@mui/icons-material/Group';
import { Box, Typography } from '@mui/material';
import React, { FC } from 'react';
import { useStyles } from './EmptyBracketTeamCard.styles';

export const EmptyBracketTeamCard: FC = () => {
  const { classes } = useStyles();

  return (
    <Box className={classes.root}>
      <Box className={classes.icon}>
        <GroupIcon />
      </Box>
      <Typography className={classes.text}>No Opponent</Typography>
    </Box>
  );
};
